import React from "react";

const RecordingButton = ({ isPlayerControlsDisable, getRecordingButton, showRecordingCTALoading }) => {
  if (isPlayerControlsDisable) {
    return null;
  }

  return (
    <>
      {getRecordingButton()}
      {showRecordingCTALoading && (
        <img src={process.env.PUBLIC_URL + "/images/Rec_Progress_Small.svg"} alt="" className="record-player-loading" />
      )}
    </>
  );
};

export default RecordingButton;
